import ShowMoreText from "react-show-more-text";
import { GoFlame } from "react-icons/go";
import { TiArrowDownThick } from "react-icons/ti";
import { AiTwotoneAlert } from "react-icons/ai";
import { readMore, readLess } from "../../../readMoreButtons";
import { isMobile } from "react-device-detect";
import { getIndicatorPopoverDetails } from "../../Popover";
import { HiPresentationChartLine } from "react-icons/hi";
import { parseIndicationFundamentalist } from "../../../../utils";
import { OverlayTrigger } from "react-bootstrap";
import getSummaryInCard, { navStyle } from "../SummaryInBottomOfCards";
import Skeleton from "react-loading-skeleton";
import { MdGroups } from "react-icons/md";
import { ProgressBar } from "react-bootstrap";
import { progressBarStyle } from "../styles";
import React from "react";
import useTheme from "../../../../context/ThemeProvider";

/**
 * Card containing fundamentalist indicators.
 */
export default function FundamentalIndicatorsCard({ analysisData, assetType }) {

  const { theme } = useTheme();

  if (!analysisData) {
    return loadingSkeleton();
  }
  if (analysisData !== "error" && analysisData !== "empty" && assetType === 1) {
    const results = analysisData.results;
    const summary = analysisData.summary;
    return (
      <div
        className="card card-crypto-portfolio animated fadeInDown"
        style={{
          borderRadius: 10,
          boxShadow: "0 0 10px rgb(28 39 60 / 10%)",
          borderColor: "var(--border-4)",
        }}
        id={!isMobile ? 'analysis-step-4' : ''}
      >
        <div className="card-body">
          <h4>
            <HiPresentationChartLine
              size={25}
              style={{ marginBottom: 2, marginRight: 3 }}
              color="#5c6bc0"
            />
            Análise Fundamentalista
          </h4>

          <ShowMoreText
            lines={2}
            more={readMore}
            less={readLess}
            expanded={false}
            truncatedEndingComponent={"..."}
            className="show-more-text"
          >
            <span style={{ textAlign: "left" }}>
              Ao analisar os dados financeiros, é possível determinar
              indicadores fundamentalistas utilizados por investidores
              profissionais, separamos os mais usados por eles em seus
              investimentos a longo prazo, se você pretende manter papeis, é
              recomendável considerar estes indicadores.
              {isMobile && (
                <span style={{ fontWeight: 500 }}>
                  {" "}
                  Você pode obter mais detalhes sobre cada indicador apenas
                  tocando nele.
                </span>
              )}
            </span>
          </ShowMoreText>
          <div className="table-responsive">
            <table className="table mg-b-0">
              <thead>
                <tr>
                  <th>Indicador</th>
                  <th>Avaliação</th>
                </tr>
              </thead>
            </table>

            <div className="mg-t-2">
              {results.map((item, i) => {
                let readableIndication = parseIndicationFundamentalist(
                  item.value,
                  theme
                );
                return (
                  <OverlayTrigger
                    placement={isMobile ? "top" : "left"}
                    delay={{ show: 100, hide: 100 }}
                    overlay={getIndicatorPopoverDetails({
                      contentCategory: 1,
                      contentId: i,
                    })}
                    key={i}
                  >
                    <div
                      id={isMobile ? 'analysis-step-4' : ''}
                      className={"invoice-info-row text-center" + (readableIndication.backgroundColor ? " highlight" : "")}
                      style={{
                        backgroundColor: readableIndication.backgroundColor,
                      }}
                    >
                      <span>{item.name}</span>
                      <span style={{ color: readableIndication.color }}>
                        <ProgressBar
                          variant={readableIndication.progressBar.variant}
                          now={readableIndication.progressBar.percent}
                          style={progressBarStyle}
                          key={i}
                        />
                        {readableIndication.name}
                      </span>
                    </div>
                  </OverlayTrigger>
                );
              })}
            </div>
          </div>
        </div>
        <nav className="nav" style={navStyle}>
          {getSummary(summary)}
        </nav>
      </div>
    );
  }
  //Check if the user selected the tab 'Fundamentalista' an it don't have FundamentalData available
  let userLocation = window.location.pathname;
  let explodeUserLocation = userLocation.split("/");
  if (explodeUserLocation[3] === "Fundamental") {
    return (
      <div className="text-center mx-auto mg-t-20 pd-10">
        {<MdGroups size={52} />}
        <h4>Análise fundamentalista indisponível</h4>
        <span className="tx-14 text-center">
          {assetType === 1
            ? "Infelizmente a análise fundamentalista não está disponível para este ativo no momento."
            : "A análise fundamentalista só está disponível para ativos do tipo 'ações'."}
        </span>
      </div>
    );
  } else {
    return <div></div>;
  }
}

export const FundamentalIndicatorsCardMemo = React.memo(
  FundamentalIndicatorsCard
);

const getSummary = (data) => {
  let all = [
    {
      name: "Compra",
      value: data.qntBuy,
      color: "#388e3c",
      icon: <GoFlame />,
    },
    {
      name: "Venda",
      value: data.qntSell,
      color: "#ef5350",
      icon: <TiArrowDownThick />,
    },
    {
      name: "Alertas",
      value: data.qntNeutral,
      color: "#424242",
      icon: <AiTwotoneAlert />,
    },
  ];
  return getSummaryInCard(all);
};

const loadingSkeleton = () => {
  return (
    <div
      className="card card-crypto-portfolio"
      style={{
        borderRadius: 10,
        boxShadow: "0 0 10px rgb(28 39 60 / 10%)",
        borderColor: "var(--border-4)",
      }}
    >
      <div className="card-body">
        <h4>
          <HiPresentationChartLine
            size={25}
            style={{ marginBottom: 2, marginRight: 3 }}
            color="#5c6bc0"
          />
          Análise Fundamentalista
        </h4>

        <ShowMoreText
          lines={3}
          more={readMore}
          less={readLess}
          expanded={false}
          truncatedEndingComponent={"..."}
          className="show-more-text"
        >
          <span style={{ textAlign: "left" }}>
            Ao analisar os dados financeiros, é possível determinar indicadores
            fundamentalistas utilizados por investidores profissionais,
            separamos os mais usados por eles em seus investimentos a longo
            prazo.
          </span>
        </ShowMoreText>
        <div className="table-responsive">
          <table className="table mg-b-0">
            <thead>
              <tr>
                <th>Indicador</th>
                <th>Avaliação</th>
              </tr>
            </thead>
          </table>

          <Skeleton
            count={8}
            style={{ marginTop: 10 }}
            height={15}
            width={"95%"}
          />
        </div>
      </div>
    </div>
  );
};
